import { createConfig, createStorage, http, injected } from '@wagmi/core';
import { chain } from '../config/chain';
import { DEV_WALLET_ENABLED, RPC_URL } from '../config/env';
import { devAccounts, localTestAccount } from './devAccounts';

export const wagmiConfig = createConfig({
  chains: [chain],
  connectors: [injected(), ...(DEV_WALLET_ENABLED ? devAccounts.map((a) => localTestAccount(a.index)) : [])],
  transports: { [chain.id]: http(RPC_URL) },
  multiInjectedProviderDiscovery: true,
  storage: createStorage({ storage: typeof window !== 'undefined' ? window.localStorage : undefined, key: 'hashcurve.wallet' }),
});
